<template>
  <div style="max-width: 1300px; min-width: 700px; margin: auto">
    <section style="padding-top: 50px; padding-bottom: 40px">
      <el-row class="title1-body">
        <span>
          <el-image
            style="
              width: clamp(100px, 9vw, 200px);
              height: clamp(100px, 9vw, 200px);
              text-align: center;
            "
            :src="url"
            :fit="fit"
          />
        </span>
        <span>Helper For Midas</span>
      </el-row>
      <div class="title2-body">
        易学易用，效率出色，符合桥梁设计师设计习惯的
      </div>
      <div class="title2-body">Midas Civil建模助手</div>
      <div style="padding-top: 40px">
        <el-button
          type="primary"
          @click="clickguide"
          style="height: 45px; font-size: 16px"
          >快速上手<el-icon><Right /></el-icon
        ></el-button>
        <el-button
          type="success"
          @click="clickinstall"
          style="height: 45px; font-size: 16px"
          >安装</el-button
        >
      </div>
    </section>
  </div>
  <div style="height: 1px; background-color: rgb(220, 220, 220)"></div>
  <div style="max-width: 960px; min-width: 550px; margin: auto">
    <section
      style="
        padding-top: 50px;
        padding-bottom: 50px;
        margin: 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      "
    >
      <div class="content1-body">
        <div style="padding-left: 15px">易学易用</div>
        <div class="content2-body">
          基于Midas Civil的mct文件格式构建，提供容易上手的使用指南和帮助文档。
        </div>
      </div>
      <div class="content1-body">
        <div style="padding-left: 15px">效率出色</div>
        <div class="content2-body">
          一键导出mct文件后，导入<br />Midas Civil几乎不需要<br />修改即可运行计算。
        </div>
      </div>
      <div class="content1-body">
        <div style="padding-left: 15px">完美适配</div>
        <div class="content2-body">
          按桥梁设计师习惯定制<br />参数输入，输入参数与<br />图纸参数匹配良好。
        </div>
      </div>
    </section>
  </div>
  <div style="height: 1px; background-color: rgb(220, 220, 220)"></div>
  <div style="max-width: 960px; min-width: 550px; margin: auto">
    <section
      style="
        padding: 15px;
        margin: 0px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      "
    >
      <el-row>
        <span
          style="
            padding-left: 100px;
            padding-top: 10px;
            padding-right: 100px;
            font-size: 18px;
            font-weight: 600;
            line-height: 1.6;
            color: rgb(50, 90, 170);
          "
          >特别推荐：</span
        >
        <span>
          <el-image
            style="width: 40px; height: 40px; text-align: center"
            :src="url1"
            :fit="fit"
        /></span>
        <span style="padding-top: 10px">
          <a :href="url2" target="_blank" class="no-underline title-resource"
            >EDFBTools —— 最好用的Autocad桥梁设计小工具集</a
          >
        </span></el-row
      >
    </section>
  </div>
  <div style="height: 1px; background-color: rgb(220, 220, 220)"></div>
  <div><AppFooter /></div>
</template>
<script>
import AppFooter from "../components/AppFooter.vue";
export default {
  data() {
    return {
      url: require("@/assets/png/modelhelper.png"),
      url1: require("@/assets/png/link1.png"),
      url2: "https://www.wolai.com/edfbtools/wbY1VB8PQP6WNsLBw8e9Lt",
      fit: "fill",
    };
  },
  components: {
    AppFooter,
  },
  methods: {
    clickguide() {
      this.$router.push({ path: "/use" });
    },
    clickinstall() {
      this.$router.push({ path: "/install" });
    },
  },
};
</script>
<style>
.title1-body {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: clamp(60px, 4vw, 110px);
  font-weight: 900;
  color: rgb(50, 90, 170);
  letter-spacing: -5px;
  align-items: center;
  justify-content: center;
  padding: 30px;
  font-size-adjust: 0.5;
}
.title2-body {
  font-size: clamp(24px, 1.6vw, 55px);
  text-align: center;
  line-height: 1.5；;
  padding: 10px;
}
.content1-body {
  width: 260px;
  padding: 28px;
  border-radius: 8px;
  text-align: left;
  font-size: 22px;
  font-weight: 600;
  line-height: 1.6;
  color: rgb(50, 90, 170);
}
.content2-body {
  padding: 15px;
  text-align: left;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6;
  color: black;
}
</style>
